import { useState } from 'react'
import * as v from 'valibot'
import type { Decoration } from 'src/services/apollo/generated/graphql'
import { DecorationType } from 'src/services/apollo/generated/graphql'
import { cn } from 'src/utils/cx'
import { MediaStreamPlayer } from '~/components/Media/MediaStreamPlayer'
import { UISpinnerLoading } from '~/components/ui/SpinnerLoading'
import { DecorationLiveBannerDataSchema } from '../schema/decoration'

export function LiveBannerItem(
  props: {
    decoration: Decoration
    type: 'preview' | 'video'
    // `Stream` doesn't support `style`
    mediaStreamPlayerStyleProps?: Pick<StyleProps, 'className'>
    displayLoadingSpinner?: boolean
  } & StyleProps,
) {
  const [loaded, setLoaded] = useState(false)

  if (props.decoration.type !== DecorationType.LiveBanner) return null

  const { output, success } = v.safeParse(
    DecorationLiveBannerDataSchema,
    props.decoration?.data,
  )

  if (!success) return null

  if (props.type === 'video') {
    return (
      <div
        className={cn(props.className, 'relative isolate')}
        style={props.style}
      >
        {props.displayLoadingSpinner && (
          <UISpinnerLoading
            loading={!loaded}
            className="absolute top-[calc(50%-8px)] left-[calc(50%-8px)] z-10"
          />
        )}
        <MediaStreamPlayer
          mediaType={output.mediaType}
          mediaSpec={output.mediaSpec}
          {...props.mediaStreamPlayerStyleProps}
          hlsStreamProps={{
            onLoaded: () => setLoaded(true),
          }}
        />
      </div>
    )
  }

  const previewMedia = output.previewMediaAsset.original
  return (
    <div className={props.className} style={props.style}>
      <img src={previewMedia} alt="Live Banner Preview" />
    </div>
  )
}
